import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Portfolio from './pages/Portfolio'
import Blog from './pages/Blog'
import Contact from './pages/Contact'
import OdooPartner from './pages/OdooPartner'
import WebDevelopment from './pages/services/WebDevelopment'
import SaaSDevelopment from './pages/services/SaaSDevelopment'
import CustomSoftware from './pages/services/CustomSoftware'
import UIUXEngineering from './pages/services/UIUXEngineering'
import AIAutomation from './pages/services/AIAutomation'
import ERPSolutions from './pages/services/ERPSolutions'
import OdooImplementation from './pages/services/OdooImplementation'
import OdooCustomization from './pages/services/OdooCustomization'
import OdooMigration from './pages/services/OdooMigration'
import OdooSupport from './pages/services/OdooSupport'
import CustomerSupport from './pages/services/CustomerSupport'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-dark-primary text-white" data-component-path="client/src/App.jsx" data-component-line="1:1" data-component-id="client/src/App.jsx:1:1">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/odoo-partner" element={<OdooPartner />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/saas-development" element={<SaaSDevelopment />} />
          <Route path="/services/custom-software" element={<CustomSoftware />} />
          <Route path="/services/ui-ux-engineering" element={<UIUXEngineering />} />
          <Route path="/services/ai-automation" element={<AIAutomation />} />
          <Route path="/services/erp-solutions" element={<ERPSolutions />} />
          <Route path="/services/odoo-implementation" element={<OdooImplementation />} />
          <Route path="/services/odoo-customization" element={<OdooCustomization />} />
          <Route path="/services/odoo-migration" element={<OdooMigration />} />
          <Route path="/services/odoo-support" element={<OdooSupport />} />
          <Route path="/services/customer-support" element={<CustomerSupport />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </Router>
  )
}

export default App